import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { ExperienceInfo } from './experienceInfo.component';
import { selectExperienceContextHomeName, selectExperienceContextHomeRoute } from '../../../modules/experience';

const mapStateToProps = createStructuredSelector({
  contextName: selectExperienceContextHomeName,
  currentExperienceParentRoute: selectExperienceContextHomeRoute,
});

export const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(ExperienceInfo);
